import request from '../request'

// 用户验证
export function checkUser(data) {
    return request({
        url: '/system/user/login',
        method: 'post',
        data: data
    })
}

export function getUserList(data) {
    return request({
        url: '/user/selectUsers',
        method: 'get',
        params: data
    })
}

export function addUser(data) {
    return request({
        url: '/user/insert',
        method: 'post',
        data: data
    })
}

export function deletedUser(data) {
    return request({
        url: '/user/deleteByKey',
        method: 'delete',
        params: data
    })
}


